import { Box, Typography } from "@mui/joy";

import { useResponsive } from "../../hooks";
import { DesktopGroupsView } from "./DesktopGroupsView";
import { MobileGroupsView } from "./MobileGroupsView";
import { useAlbumGroups } from "./hooks";
import { AlbumWidgetProps } from "./types";

export default function AlbumWidget(props: AlbumWidgetProps) {
    const { sections, taskId, projectId, assetType, heading, subheading } = props;
    const { isMobile } = useResponsive();
    const { groups, loading, updateGroupImages } = useAlbumGroups({
        sections,
        taskId,
        assetType,
    });

    return (
        <Box mt={heading || subheading ? 2 : 0}>
            {(heading || subheading) && (
                <Box mb={2}>
                    {heading && <Typography level="title-md">{heading}</Typography>}
                    {subheading && (
                        <Typography level="body-sm" color="neutral">
                            {subheading}
                        </Typography>
                    )}
                </Box>
            )}

            {isMobile ? (
                <MobileGroupsView
                    groups={groups}
                    taskId={taskId}
                    projectId={projectId}
                    loading={loading}
                    onGroupImagesChange={updateGroupImages}
                />
            ) : (
                <DesktopGroupsView
                    groups={groups}
                    taskId={taskId}
                    projectId={projectId}
                    loading={loading}
                    onGroupImagesChange={updateGroupImages}
                />
            )}
        </Box>
    );
}

export type { AlbumWidgetProps, AlbumGroup, AlbumSectionDefinition } from "./types";
